import { IMessage, MessageType } from "@common/models";
import { AppAction, IAppAction } from '@misc/Action';
import { store } from '@misc/Reducer';
import { ReactNode } from "react";
import Translate from './Translate';

export interface INotification {
    success(code: string | ReactNode, ...placeholders: any[]): void;
    error(code: string | ReactNode, ...placeholders: any[]): void;
    warning(code: string | ReactNode, ...placeholders: any[]): void;
    (toastMessage: IMessage): void;
}

const Notification: INotification = (toastMessage: IMessage) => {
    switch (toastMessage.type) {
        case MessageType.Success:
            return Notification.success(toastMessage.code, toastMessage.text);
        case MessageType.Error:
            return Notification.error(toastMessage.code, toastMessage.text);
        case MessageType.Warning:
            return Notification.warning(toastMessage.code, toastMessage.text);
    }
};

Notification.success = (code: string, text?: string) => {
    toast(code, MessageType.Success, text);
}

Notification.error = (code: string, text?: string) => {
    toast(code, MessageType.Error, text);
}

Notification.warning = (code: string, text?: string) => {
    toast(code, MessageType.Warning, text);
}

const toast = (code: string, type: MessageType = MessageType.Information, text?: string) => {
    const toasts = store.getState().toasts;
    let toastMessage: IMessage = {
        type: type,
        code: code,
        text: Translate.tr(code) === code ? text || code : Translate.tr(code)
    };
    toasts.push(toastMessage);
    store.dispatch<IAppAction>({ type: AppAction.Toasts, payload: { toasts } });
}

export default Notification;